import ImageScaleType from "../image_converter/ImageScaleType";
import OutputDimentionScale from "../merge_images/OutputDimentionScale";
import OutputLayout from "../merge_images/OutputLayout";
import {
  releaseCanvas,
  canvasToBlob,
  drawTextOnCanvas,
  drawImageOnCanvas,
  convertImageObject,
  loadImageFromFile,
} from "../Utils";
import { ExtendedFile } from "../misc_components/MiscUploadPDFView";

//watermark image
//add watermark text to image
//add watermark image to image
//imageFile = image to watermark on
export async function watermarkImageFile(imageFile, configurations, callback) {
  console.log("Configuration: ", configurations);
  //canvas
  let canvas = document.createElement("canvas");
  canvas.setAttribute("className", "canv");
  // Get the 2D drawing context
  const ctx = canvas.getContext("2d");

  //load main image
  const imageMain = new Image(); // Create a new Image object

  // Set crossOrigin to "Anonymous" if loading images from different domains
  // to avoid potential CORS issues that restrict canvas data access.
  imageMain.crossOrigin = "Anonymous";
  imageMain.src = URL.createObjectURL(imageFile);

  imageMain.onload = async () => {
    //image width, height
    const imageWidth = imageMain.width;
    const imageHeight = imageMain.height;

    //set canvas dimension
    canvas.width = imageWidth;
    canvas.height = imageHeight;

    //draw image
    //at 0, 0
    ctx.drawImage(imageMain, 0, 0);

    //draw image on canvas
    //with configurations
    canvas = await drawImageOnCanvas(canvas, configurations);

    //draw text on canvas
    //with configurations
    canvas = await drawTextOnCanvas(canvas, configurations);

    //convert to blob
    const blob = await canvasToBlob(
      canvas,
      1.0,
      imageFile.type ?? "image/jpeg",
    );

    //return
    callback(blob);
    //release canvas
    releaseCanvas(canvas);
  };

  // Optional: Handle errors during image loading
  imageMain.onerror = (err) => {
    console.error("Error loading image:", err);
    //return
    callback(null);
    //release canvas
    releaseCanvas(canvas);
  };
}

//merge images
export async function mergeImages(imageFiles, configurations, callback) {
  console.log("Configuration: ", configurations);
  //canvas
  let canvas = document.createElement("canvas");
  canvas.setAttribute("className", "canv");
  // Get the 2D drawing context
  const ctx = canvas.getContext("2d");

  //image array
  let images = [];
  //loop
  //load all image
  for (let i = 0; i < imageFiles.length; i++) {
    //load image
    const image = await loadImageFromFile(imageFiles[i]);
    //check
    if (image !== null) {
      //add
      images.push(image);
    }
  }

  //try - catch
  try {
    //drawn images combined length
    let drawnImagesCombinedLength = 0;

    //check
    if (configurations.layout === OutputLayout.HORIZONTAL) {
      //heights
      let imageHeightsArr = images.map((item) => item.height);
      //max image height
      //set height to max height of all images
      let maxHeight = Math.max(...imageHeightsArr);
      //images total width
      let totalWidthImages = images.reduce((accumulator, currentValue) => {
        // return the updated accumulator
        return accumulator + currentValue.width;
      }, 0);

      // //set canvas width
      canvas.width =
        2 * configurations.margin +
        (imageFiles.length - 1) * configurations.padding +
        totalWidthImages;
      canvas.height = maxHeight + 2 * configurations.margin;

      //fill style
      ctx.fillStyle = configurations.bgcolor;
      //fill rect
      ctx.fillRect(0, 0, canvas.width, canvas.height);

      //check
      if (configurations.outputDimensionType === OutputDimentionScale.AUTO) {
        //loop
        for (let i = 0; i < images.length; i++) {
          //image
          const image = images[i];
          //image size
          const imgSize = { width: image.width, height: maxHeight };
          //convert image
          //scale image w.r.t drawmode and fit inside desired rect of size
          //release canvas after use
          const convtImageCanvas = await convertImageObject(image, {
            mimetype: configurations.type,
            quality: 1, // 0 - 1
            scaleType: ImageScaleType.FIXED,
            grayscale: false,
            scale: 1, // 0 - 1
            width: imgSize.width,
            height: imgSize.height,
            drawMode: configurations.drawMode,
          });

          //place image
          //draw image at origin
          //image origin
          const imgOrigin = {
            x:
              drawnImagesCombinedLength +
              configurations.margin +
              i * configurations.padding,
            y: configurations.margin,
          };

          //draw image
          ctx.drawImage(convtImageCanvas, imgOrigin.x, imgOrigin.y);

          //set combined length
          drawnImagesCombinedLength =
            drawnImagesCombinedLength + convtImageCanvas.width;
          //release canvas
          releaseCanvas(convtImageCanvas);
        }
      } else if (
        configurations.outputDimensionType === OutputDimentionScale.FIXED_SIZE
      ) {
        // //set canvas width
        canvas.width = configurations.outputDimension.width;
        canvas.height = configurations.outputDimension.height;

        //fill style
        ctx.fillStyle = configurations.bgcolor;
        //fill rect
        ctx.fillRect(0, 0, canvas.width, canvas.height);

        //img rect width
        const imgRectWidth =
          (canvas.width -
            configurations.margin * 2 -
            (images.length - 1) * configurations.padding) /
          images.length;
        //img rect height
        const imgRectHeight = canvas.height - configurations.margin * 2;

        //image size
        const imgSize = { width: imgRectWidth, height: imgRectHeight };

        //loop images
        for (let i = 0; i < images.length; i++) {
          //image
          const image = images[i];

          //convert image
          //scale image w.r.t drawmode and fit inside desired rect of size
          //release canvas after use
          const convtImageCanvas = await convertImageObject(image, {
            mimetype: configurations.type,
            quality: 1, // 0 - 1
            scaleType: ImageScaleType.FIXED,
            grayscale: false,
            scale: 1, // 0 - 1
            width: imgSize.width,
            height: imgSize.height,
            drawMode: configurations.drawMode,
          });

          //place image
          //draw image at origin
          //image origin
          const imgOrigin = {
            x:
              drawnImagesCombinedLength +
              configurations.margin +
              i * configurations.padding,
            y: configurations.margin,
          };

          //draw image
          ctx.drawImage(convtImageCanvas, imgOrigin.x, imgOrigin.y);

          //set combined length
          drawnImagesCombinedLength =
            drawnImagesCombinedLength + convtImageCanvas.width;
          //release canvas
          releaseCanvas(convtImageCanvas);
        }
      }
    } else if (configurations.layout === OutputLayout.VERTICAL) {
      //width
      let imageWidthsArr = images.map((item) => item.width);
      //max image width
      //set width to max width of all images
      let maxWidth = Math.max(...imageWidthsArr);
      //images total height
      let totalHeightImages = images.reduce((accumulator, currentValue) => {
        // return the updated accumulator
        return accumulator + currentValue.height;
      }, 0);

      // //set canvas width
      canvas.width = maxWidth + 2 * configurations.margin;

      canvas.height =
        2 * configurations.margin +
        (imageFiles.length - 1) * configurations.padding +
        totalHeightImages;

      //fill style
      ctx.fillStyle = configurations.bgcolor;
      //fill rect
      ctx.fillRect(0, 0, canvas.width, canvas.height);

      //check
      if (configurations.outputDimensionType === OutputDimentionScale.AUTO) {
        //loop
        for (let i = 0; i < images.length; i++) {
          //image
          const image = images[i];
          //image size
          const imgSize = { width: maxWidth, height: image.height };
          //convert image
          //scale image w.r.t drawmode and fit inside desired rect of size
          //release canvas after use
          const convtImageCanvas = await convertImageObject(image, {
            mimetype: configurations.type,
            quality: 1, // 0 - 1
            scaleType: ImageScaleType.FIXED,
            grayscale: false,
            scale: 1, // 0 - 1
            width: imgSize.width,
            height: imgSize.height,
            drawMode: configurations.drawMode,
          });

          //place image
          //draw image at origin
          //image origin
          const imgOrigin = {
            x: configurations.margin,
            y:
              drawnImagesCombinedLength +
              configurations.margin +
              i * configurations.padding,
          };

          //draw image
          ctx.drawImage(convtImageCanvas, imgOrigin.x, imgOrigin.y);

          //set combined length
          drawnImagesCombinedLength =
            drawnImagesCombinedLength + convtImageCanvas.height;
          //release canvas
          releaseCanvas(convtImageCanvas);
        }
      } else if (
        configurations.outputDimensionType === OutputDimentionScale.FIXED_SIZE
      ) {
        // //set canvas width
        canvas.width = configurations.outputDimension.width;
        canvas.height = configurations.outputDimension.height;

        //fill style
        ctx.fillStyle = configurations.bgcolor;
        //fill rect
        ctx.fillRect(0, 0, canvas.width, canvas.height);

        //img rect width
        const imgRectWidth = canvas.height - configurations.margin * 2;
        //img rect height
        const imgRectHeight =
          (canvas.height -
            configurations.margin * 2 -
            (images.length - 1) * configurations.padding) /
          images.length;

        //image size
        const imgSize = { width: imgRectWidth, height: imgRectHeight };

        //loop images
        for (let i = 0; i < images.length; i++) {
          //image
          const image = images[i];

          //convert image
          //scale image w.r.t drawmode and fit inside desired rect of size
          //release canvas after use
          const convtImageCanvas = await convertImageObject(image, {
            mimetype: configurations.type,
            quality: 1, // 0 - 1
            scaleType: ImageScaleType.FIXED,
            grayscale: false,
            scale: 1, // 0 - 1
            width: imgSize.width,
            height: imgSize.height,
            drawMode: configurations.drawMode,
          });

          //place image
          //draw image at origin
          //image origin
          const imgOrigin = {
            x: configurations.margin,
            y:
              drawnImagesCombinedLength +
              configurations.margin +
              i * configurations.padding,
          };

          //draw image
          ctx.drawImage(convtImageCanvas, imgOrigin.x, imgOrigin.y);

          //set combined length
          drawnImagesCombinedLength =
            drawnImagesCombinedLength + convtImageCanvas.height;
          //release canvas
          releaseCanvas(convtImageCanvas);
        }
      }
    } else if (configurations.layout === OutputLayout.GRID) {
      //width
      let imageWidthsArr = images.map((item) => item.width);
      //max image width
      //set width to max width of all images
      let maxWidth = Math.max(...imageWidthsArr);
      //heights
      let imageHeightsArr = images.map((item) => item.height);
      //max image height
      //set height to max height of all images
      let maxHeight = Math.max(...imageHeightsArr);

      //grid col count
      const gridColCount = Math.ceil(Math.sqrt(imageFiles.length));

      //set canvas width height
      canvas.width =
        configurations.outputDimensionType === OutputDimentionScale.AUTO
          ? configurations.margin * 2 +
            (gridColCount - 1) * configurations.padding +
            maxWidth * gridColCount
          : configurations.outputDimension.width;
      canvas.height =
        configurations.outputDimensionType === OutputDimentionScale.AUTO
          ? configurations.margin * 2 +
            (gridColCount - 1) * configurations.padding +
            maxHeight * gridColCount
          : configurations.outputDimension.height;

      //fill style
      ctx.fillStyle = configurations.bgcolor;
      //fill rect
      ctx.fillRect(0, 0, canvas.width, canvas.height);

      //image rect size
      //img rect width
      const imgRectWidth =
        (canvas.width -
          configurations.margin * 2 -
          (gridColCount - 1) * configurations.padding) /
        gridColCount;
      //img rect height
      const imgRectHeight =
        (canvas.height -
          configurations.margin * 2 -
          (gridColCount - 1) * configurations.padding) /
        gridColCount;

      //image size
      const imgSize = { width: imgRectWidth, height: imgRectHeight };

      //loop images col
      for (let i = 0; i < gridColCount; i++) {
        //loop images row
        for (let j = 0; j < gridColCount; j++) {
          //check
          const index = i * gridColCount + j;
          //check
          if (index < images.length) {
            //image
            const image = images[index];

            //convert image
            //scale image w.r.t drawmode and fit inside desired rect of size
            //release canvas after use
            const convtImageCanvas = await convertImageObject(image, {
              mimetype: configurations.type,
              quality: 1, // 0 - 1
              scaleType: ImageScaleType.FIXED,
              grayscale: false,
              scale: 1, // 0 - 1
              width: imgSize.width,
              height: imgSize.height,
              drawMode: configurations.drawMode,
            });

            //place image
            //draw image at origin
            //image origin
            const imgOrigin = {
              x:
                configurations.margin +
                j * configurations.padding +
                j * imgSize.width,
              y:
                configurations.margin +
                i * configurations.padding +
                i * imgSize.height,
            };

            //draw image
            ctx.drawImage(convtImageCanvas, imgOrigin.x, imgOrigin.y);

            //set combined length
            drawnImagesCombinedLength = 0;
            //release canvas
            releaseCanvas(convtImageCanvas);
          }
        }
      }
    }
  } catch {}

  //callback
  callback(await canvasToBlob(canvas, 1.0, configurations.type));
  //release canvas
  releaseCanvas(canvas);
}

//split image into parts
export async function splitImage(imageFile, configurations, callback) {
  console.log("Configuration: ", configurations);

  //try - catch
  try {
    //load image
    const image = await loadImageFromFile(imageFile);
    //check
    if (configurations.outputDimensionType === OutputDimentionScale.AUTO) {
      //split rect width
      const splitRectWidth = Math.ceil(image.width / configurations.colCount);
      //split rect height
      const splitRectHeight = Math.ceil(image.height / configurations.rowCount);

      //images
      let splitImages = [];
      //loop
      for (let i = 0; i < configurations.rowCount; i++) {
        for (let j = 0; j < configurations.colCount; j++) {
          //canvas
          let canvas = document.createElement("canvas");
          canvas.setAttribute("className", "canv");
          // Get the 2D drawing context
          const ctx = canvas.getContext("2d");

          //set canvas width height
          canvas.width = splitRectWidth + configurations.margin * 2;
          canvas.height = splitRectHeight + configurations.margin * 2;

          //fill
          ctx.fillStyle = "#000000";
          ctx.fillRect(0, 0, canvas.width, canvas.height);

          //draw cropped image
          ctx.drawImage(
            image, //source image
            j * splitRectWidth, //crop rect x
            i * splitRectHeight, //crop rect y
            splitRectWidth, //crop rect width
            splitRectHeight, //crop rect height
            configurations.margin, //destination canvas origin
            configurations.margin,
            splitRectWidth, //destination canvas width
            splitRectHeight, //destination canvas height
          );

          //blob
          const blob = await canvasToBlob(canvas, 1.0, configurations.type);
          // Optional: Create a JavaScript File object from the blob for easier handling (e.g., for uploads)
          const fileOptions = {
            type: blob.type,
          };
          //create file object
          const file = new ExtendedFile(
            [blob],
            `split_image_${i * configurations.colCount + j}`,
            fileOptions,
          );
          //add
          splitImages.push(file);
          //release canvas
          releaseCanvas(canvas);
        }
      }

      //callback
      callback(splitImages);
    } else if (
      configurations.outputDimensionType === OutputDimentionScale.FIXED_SIZE
    ) {
      //split rect width
      const splitRectWidth = Math.max(10, configurations.outputDimension.width);
      //split rect height
      const splitRectHeight = Math.max(
        10,
        configurations.outputDimension.height,
      );

      //images
      let splitImages = [];
      //width
      let imgWidth = image.width;
      //height
      let imgHeight = image.height;

      //row count
      const rowCount = Math.ceil(imgWidth / splitRectWidth);
      //col count
      const colCount = Math.ceil(imgHeight / splitRectHeight);

      //loop
      for (let i = 0; i < rowCount; i++) {
        for (let j = 0; j < colCount; j++) {
          //canvas
          let canvas = document.createElement("canvas");
          canvas.setAttribute("className", "canv");
          // Get the 2D drawing context
          const ctx = canvas.getContext("2d");

          //set canvas width height
          canvas.width = splitRectWidth + configurations.margin * 2;
          canvas.height = splitRectHeight + configurations.margin * 2;

          //fill
          ctx.fillStyle = "#000000";
          ctx.fillRect(0, 0, canvas.width, canvas.height);

          //draw cropped image
          ctx.drawImage(
            image, //source image
            j * splitRectWidth, //crop rect x
            i * splitRectHeight, //crop rect y
            splitRectWidth, //crop rect width
            splitRectHeight, //crop rect height
            configurations.margin, //destination canvas origin
            configurations.margin,
            splitRectWidth, //destination canvas width
            splitRectHeight, //destination canvas height
          );

          //blob
          const blob = await canvasToBlob(canvas, 1.0, configurations.type);
          // Optional: Create a JavaScript File object from the blob for easier handling (e.g., for uploads)
          const fileOptions = {
            type: blob.type,
          };
          //create file object
          const file = new ExtendedFile(
            [blob],
            `split_image_${i * configurations.colCount + j}`,
            fileOptions,
          );
          //add
          splitImages.push(file);
          //release canvas
          releaseCanvas(canvas);
        }
      }

      //callback
      callback(splitImages);
    }
  } catch {}
}

//rotate image
export async function rotateFlipImage(imageFile, configurations, callback) {
  console.log("Configurations: ", configurations);

  //canvas
  let canvas = document.createElement("canvas");
  canvas.setAttribute("className", "canv");
  // Get the 2D drawing context
  const ctx = canvas.getContext("2d");

  //fliph
  //swap flip axis for rotated axis
  let flipH =
    (configurations.rotate / 90) % 2 === 0
      ? configurations.flipH
      : configurations.flipV;
  //flipv
  //swap flip axis for rotated axis
  let flipV =
    (configurations.rotate / 90) % 2 === 0
      ? configurations.flipV
      : configurations.flipH;

  //try - catch
  try {
    //load image
    const image = await loadImageFromFile(imageFile);
    //canvas width height
    canvas.width =
      (configurations.rotate / 90) % 2 === 0 ? image.width : image.height;
    canvas.height =
      (configurations.rotate / 90) % 2 === 0 ? image.height : image.width;

    // Save the current canvas state
    ctx.save();
    // Translate the origin to the center of the desired image position
    ctx.translate(canvas.width * 0.5, canvas.height * 0.5);
    //flip
    ctx.scale(flipH ? -1 : 1, flipV ? -1 : 1);
    // Rotate the canvas context by 45 degrees (converted to radians)
    var angleInRadians = (configurations.rotate * Math.PI) / 180;
    // Rotate the canvas
    ctx.rotate(angleInRadians);
    // Draw the image, positioned relative to the new origin
    ctx.drawImage(image, -image.width * 0.5, -image.height * 0.5);
    // Restore the canvas to its original state
    ctx.restore();
  } catch {}

  //callback
  callback(await canvasToBlob(canvas, 1.0, configurations.type));
  //release canvas
  releaseCanvas(canvas);
}

//crop image
export async function cropImage(
  imageSrc,
  cropX,
  cropY,
  cropWidth,
  cropHeight,
  mimeType,
) {
  //return
  return new Promise((resolve, reject) => {
    //Create an Image object for the source image
    const inputImage = new Image();
    inputImage.src = URL.createObjectURL(imageSrc);
    inputImage.crossOrigin = "anonymous"; // Needed for images from different domains

    //on load image
    inputImage.onload = async () => {
      //Get the destination canvas element and its context
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");

      //Set the canvas dimensions to match the desired output crop size
      canvas.width = cropWidth;
      canvas.height = cropHeight;

      //Perform the programmatic crop using drawImage()
      ctx.drawImage(
        inputImage,
        cropX,
        cropY,
        cropWidth,
        cropHeight, // Source parameters (sx, sy, sWidth, sHeight)
        0,
        0,
        cropWidth,
        cropHeight, // Destination parameters (dx, dy, dWidth, dHeight)
      );

      //convert to blob
      const blob = await canvasToBlob(canvas, 1.0, mimeType);
      //release canvas
      releaseCanvas(canvas);
      //callback
      resolve(blob);
    };

    //on error
    inputImage.onerror = () => {
      //callback
      resolve(null);
    };
  });
}
